// src/scenes/dashboard/config/columns.js
  const optichiller2CompColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
    { field: "presionSuccionComp1", headerName: "Pres. Succión Compresor 1", minWidth: 220, flex: 1 },
    { field: "presionSuccionComp2", headerName: "Pres. Succión Compresor 2", minWidth: 220, flex: 1 },
    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },
    { field: "tempTorreEntrada", headerName: "Temp. Torre Entrada", minWidth: 200, flex: 1 },
    { field: "tempTorreSalida", headerName: "Temp. Torre Salida", minWidth: 200, flex: 1 },
    { field: "tempDescargaComp1", headerName: "Temp. Descarga Compresor 1", minWidth: 200, flex: 1 },
    { field: "tempDescargaComp2", headerName: "Temp. Descarga Compresor 2", minWidth: 200, flex: 1 },
    { field: "presionDescargaComp1", headerName: "Presión Descarga Comp. 1", minWidth: 200, flex: 1 },
    { field: "presionDescargaComp2", headerName: "Presión Descarga Comp. 2", minWidth: 200, flex: 1 },
  ];

  const centrifugaColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "tempProcesoEntrada", headerName: "Temp Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida", headerName: "Temp Proceso Salida", minWidth: 200, flex: 1 },

    { field: "tempAguaTorreEntrada", headerName: "Temp Agua Torre Entrada", minWidth: 230, flex: 1 },
    { field: "tempAguaTorreSalida", headerName: "Temp Agua Torre Salida", minWidth: 230, flex: 1 },

    { field: "presAbsolutaSuccion", headerName: "Pres Absoluta de Succión", minWidth: 230, flex: 1 },
    { field: "presAbsolutaDescarga", headerName: "Pres Absoluta de Descarga", minWidth: 230, flex: 1 },

    { field: "tempDescarga", headerName: "Temp Descarga", minWidth: 200, flex: 1 },
  ];

  const cotherm2CompColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "presSuccionComp1",     headerName: "Pres. Succion Comp 1", minWidth: 180, flex: 1 },
    { field: "presSuccionComp2",     headerName: "Pres. Succion Comp 2", minWidth: 180, flex: 1 },
    { field: "presionDescargaComp1", headerName: "Presion Descarga Comp 1", minWidth: 200, flex: 1 },
    { field: "presionDescargaComp2", headerName: "Presion Descarga Comp 2", minWidth: 200, flex: 1 },
    { field: "tempProcesoEntrada",   headerName: "Temp. Proceso Entrada", minWidth: 180, flex: 1 },
    { field: "tempProcesoSalida",    headerName: "Temp. Proceso Salida",  minWidth: 180, flex: 1 },
    { field: "tempEvapSalidaC1",     headerName: "Temp. Evap Salida C1",  minWidth: 200, flex: 1 },
    { field: "tempEvapSalidaC2",     headerName: "Temp. Evap Salida C2",  minWidth: 200, flex: 1 },
    { field: "tempDescargaComp1",    headerName: "Temp. Descarga Comp 1", minWidth: 200, flex: 1 },
    { field: "tempDescargaComp2",    headerName: "Temp. Descarga Comp 2", minWidth: 200, flex: 1 },
  ];

  const cotherm4CompColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "tempHeladaEntrada",   headerName: "Temp. Helada Entrada",      minWidth: 200, flex: 1 },
    { field: "tempHeladaSalida",    headerName: "Temp. Helada Salida",       minWidth: 200, flex: 1 },
    { field: "tempCondEntrada",     headerName: "Temp. Condensación Entrada",minWidth: 220, flex: 1 },
    { field: "tempCondSalida",      headerName: "Temp. Condensación Salida", minWidth: 220, flex: 1 },

    { field: "presSuccionComp1",    headerName: "Pres. Succion Comp 1",      minWidth: 180, flex: 1 },
    { field: "presSuccionComp2",    headerName: "Pres. Succion Comp 2",      minWidth: 180, flex: 1 },
    { field: "presSuccionComp3",    headerName: "Pres. Succion Comp 3",      minWidth: 180, flex: 1 },
    { field: "presSuccionComp4",    headerName: "Pres. Succion Comp 4",      minWidth: 180, flex: 1 },

    { field: "presionDescargaComp1", headerName: "Presion Descarga Comp 1",  minWidth: 200, flex: 1 },
    { field: "presionDescargaComp2", headerName: "Presion Descarga Comp 2",  minWidth: 200, flex: 1 },
    { field: "presionDescargaComp3", headerName: "Presion Descarga Comp 3",  minWidth: 200, flex: 1 },
    { field: "presionDescargaComp4", headerName: "Presion Descarga Comp 4",  minWidth: 200, flex: 1 },

    { field: "presionDifAceiteComp1", headerName: "Presion Dif. Aceite Comp 1", minWidth: 230, flex: 1 },
    { field: "presionDifAceiteComp2", headerName: "Presion Dif. Aceite Comp 2", minWidth: 230, flex: 1 },
    { field: "presionDifAceiteComp3", headerName: "Presion Dif. Aceite Comp 3", minWidth: 230, flex: 1 },
    { field: "presionDifAceiteComp4", headerName: "Presion Dif. Aceite Comp 4", minWidth: 230, flex: 1 },
  ];

  const cotherm4Comp2CCColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "tempHeladaEntrada",   headerName: "Temp. Helada Entrada",       minWidth: 200, flex: 1 },
    { field: "tempHeladaSalida",    headerName: "Temp. Helada Salida",        minWidth: 200, flex: 1 },
    { field: "tempCondEntrada",     headerName: "Temp. Condensación Entrada", minWidth: 220, flex: 1 },
    { field: "tempCondSalida",      headerName: "Temp. Condensación Salida",  minWidth: 220, flex: 1 },
    { field: "tempCondSecEntrada",  headerName: "Temp. Cond. Sec Entrada",    minWidth: 220, flex: 1 },
    { field: "tempCondSecSalida",   headerName: "Temp. Cond. Sec Salida",     minWidth: 220, flex: 1 },

    { field: "presSuccionComp1",    headerName: "Pres. Succion Comp 1",       minWidth: 180, flex: 1 },
    { field: "presSuccionComp2",    headerName: "Pres. Succion Comp 2",       minWidth: 180, flex: 1 },
    { field: "presSuccionComp3",    headerName: "Pres. Succion Comp 3",       minWidth: 180, flex: 1 },
    { field: "presSuccionComp4",    headerName: "Pres. Succion Comp 4",       minWidth: 180, flex: 1 },

    { field: "presionDescargaComp1", headerName: "Presion Descarga Comp 1",   minWidth: 200, flex: 1 },
    { field: "presionDescargaComp2", headerName: "Presion Descarga Comp 2",   minWidth: 200, flex: 1 },
    { field: "presionDescargaComp3", headerName: "Presion Descarga Comp 3",   minWidth: 200, flex: 1 },
    { field: "presionDescargaComp4", headerName: "Presion Descarga Comp 4",   minWidth: 200, flex: 1 },

    { field: "presionDifAceiteComp1", headerName: "Presion Dif. Aceite Comp 1", minWidth: 230, flex: 1 },
    { field: "presionDifAceiteComp2", headerName: "Presion Dif. Aceite Comp 2", minWidth: 230, flex: 1 },
    { field: "presionDifAceiteComp3", headerName: "Presion Dif. Aceite Comp 3", minWidth: 230, flex: 1 },
    { field: "presionDifAceiteComp4", headerName: "Presion Dif. Aceite Comp 4", minWidth: 230, flex: 1 },
  ];

  const ezChiller2CompCT6Columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "presionSuccionComp1", headerName: "Presión Succión C1", minWidth: 200, flex: 1 },
    { field: "presionSuccionComp2", headerName: "Presión Succión C2", minWidth: 200, flex: 1 },

    { field: "presionDescargaComp1", headerName: "Presión Descarga C1", minWidth: 210, flex: 1 },
    { field: "presionDescargaComp2", headerName: "Presión Descarga C2", minWidth: 210, flex: 1 },

    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },

    { field: "tempRefrCondensado1", headerName: "Temp. Refr. Condensado C1", minWidth: 230, flex: 1 },
    { field: "tempRefrCondensado2", headerName: "Temp. Refr. Condensado C2", minWidth: 230, flex: 1 },

    { field: "tempDescargaComp1", headerName: "Temp. Descarga Comp 1", minWidth: 210, flex: 1 },
    { field: "tempDescargaComp2", headerName: "Temp. Descarga Comp 2", minWidth: 210, flex: 1 },
  ];

  const fscColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 160, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida",  headerName: "Temp. Proceso Salida",  minWidth: 200, flex: 1 },

    // M1
    { field: "m1TempEvapSalida", headerName: "M1 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m1TempDescarga",   headerName: "M1 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m1PresSuccion",    headerName: "M1 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m1PresDescarga",   headerName: "M1 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m1NumeroEquipo",   headerName: "M1 Número de Equipo", minWidth: 180, flex: 1 },

    // M2
    { field: "m2TempEvapSalida", headerName: "M2 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m2TempDescarga",   headerName: "M2 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m2PresSuccion",    headerName: "M2 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m2PresDescarga",   headerName: "M2 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m2NumeroEquipo",   headerName: "M2 Número de Equipo", minWidth: 180, flex: 1 },

    // M3
    { field: "m3TempEvapSalida", headerName: "M3 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m3TempDescarga",   headerName: "M3 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m3PresSuccion",    headerName: "M3 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m3PresDescarga",   headerName: "M3 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m3NumeroEquipo",   headerName: "M3 Número de Equipo", minWidth: 180, flex: 1 },

    // M4
    { field: "m4TempEvapSalida", headerName: "M4 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m4TempDescarga",   headerName: "M4 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m4PresSuccion",    headerName: "M4 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m4PresDescarga",   headerName: "M4 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m4NumeroEquipo",   headerName: "M4 Número de Equipo", minWidth: 180, flex: 1 },

    // M5
    { field: "m5TempEvapSalida", headerName: "M5 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m5TempDescarga",   headerName: "M5 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m5PresSuccion",    headerName: "M5 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m5PresDescarga",   headerName: "M5 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m5NumeroEquipo",   headerName: "M5 Número de Equipo", minWidth: 180, flex: 1 },

    // M6
    { field: "m6TempEvapSalida", headerName: "M6 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m6TempDescarga",   headerName: "M6 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m6PresSuccion",    headerName: "M6 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m6PresDescarga",   headerName: "M6 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m6NumeroEquipo",   headerName: "M6 Número de Equipo", minWidth: 180, flex: 1 },

    // M7
    { field: "m7TempEvapSalida", headerName: "M7 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m7TempDescarga",   headerName: "M7 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m7PresSuccion",    headerName: "M7 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m7PresDescarga",   headerName: "M7 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m7NumeroEquipo",   headerName: "M7 Número de Equipo", minWidth: 180, flex: 1 },

    // M8
    { field: "m8TempEvapSalida", headerName: "M8 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m8TempDescarga",   headerName: "M8 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m8PresSuccion",    headerName: "M8 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m8PresDescarga",   headerName: "M8 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m8NumeroEquipo",   headerName: "M8 Número de Equipo", minWidth: 180, flex: 1 },

    // M9
    { field: "m9TempEvapSalida", headerName: "M9 Temp. Evap Salida", minWidth: 200, flex: 1 },
    { field: "m9TempDescarga",   headerName: "M9 Temp. Descarga",   minWidth: 200, flex: 1 },
    { field: "m9PresSuccion",    headerName: "M9 Pres. Succión",    minWidth: 180, flex: 1 },
    { field: "m9PresDescarga",   headerName: "M9 Pres. Descarga",   minWidth: 180, flex: 1 },
    { field: "m9NumeroEquipo",   headerName: "M9 Número de Equipo", minWidth: 180, flex: 1 },

    // M10
    { field: "m10TempEvapSalida", headerName: "M10 Temp. Evap Salida", minWidth: 210, flex: 1 },
    { field: "m10TempDescarga",   headerName: "M10 Temp. Descarga",   minWidth: 210, flex: 1 },
    { field: "m10PresSuccion",    headerName: "M10 Pres. Succión",    minWidth: 190, flex: 1 },
    { field: "m10PresDescarga",   headerName: "M10 Pres. Descarga",   minWidth: 190, flex: 1 },
    { field: "m10NumeroEquipo",   headerName: "M10 Número de Equipo", minWidth: 190, flex: 1 },
  ];

  const fscUnicoColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 160, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "presSuccionC1", headerName: "Pres. Succión Comp 1", minWidth: 200, flex: 1 },
    { field: "presSuccionC2", headerName: "Pres. Succión Comp 2", minWidth: 200, flex: 1 },

    { field: "presDescargaC1", headerName: "Pres. Descarga Comp 1", minWidth: 210, flex: 1 },
    { field: "presDescargaC2", headerName: "Pres. Descarga Comp 2", minWidth: 210, flex: 1 },

    { field: "superheatC1", headerName: "Superheat Comp 1", minWidth: 200, flex: 1 },
    { field: "superheatC2", headerName: "Superheat Comp 2", minWidth: 200, flex: 1 },

    { field: "tempEvapEnt", headerName: "Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "tempEvapSal", headerName: "Temp. Evap Salida", minWidth: 200, flex: 1 },

    { field: "tempSuccionC1", headerName: "Temp. Succión Comp 1", minWidth: 200, flex: 1 },
    { field: "tempSuccionC2", headerName: "Temp. Succión Comp 2", minWidth: 200, flex: 1 },
  ];

  const fscV3Columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 160, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida",  headerName: "Temp. Proceso Salida",  minWidth: 200, flex: 1 },

    // ===== M1 =====
    { field: "m1TempEvapSalida",  headerName: "M1 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m1TempEvapEntrada", headerName: "M1 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m1PresDescC1",      headerName: "M1 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m1PresDescC2",      headerName: "M1 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m1NumeroEquipo",    headerName: "M1 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M2 =====
    { field: "m2TempEvapSalida",  headerName: "M2 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m2TempEvapEntrada", headerName: "M2 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m2PresDescC1",      headerName: "M2 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m2PresDescC2",      headerName: "M2 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m2NumeroEquipo",    headerName: "M2 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M3 =====
    { field: "m3TempEvapSalida",  headerName: "M3 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m3TempEvapEntrada", headerName: "M3 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m3PresDescC1",      headerName: "M3 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m3PresDescC2",      headerName: "M3 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m3NumeroEquipo",    headerName: "M3 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M4 =====
    { field: "m4TempEvapSalida",  headerName: "M4 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m4TempEvapEntrada", headerName: "M4 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m4PresDescC1",      headerName: "M4 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m4PresDescC2",      headerName: "M4 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m4NumeroEquipo",    headerName: "M4 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M5 =====
    { field: "m5TempEvapSalida",  headerName: "M5 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m5TempEvapEntrada", headerName: "M5 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m5PresDescC1",      headerName: "M5 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m5PresDescC2",      headerName: "M5 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m5NumeroEquipo",    headerName: "M5 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M6 =====
    { field: "m6TempEvapSalida",  headerName: "M6 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m6TempEvapEntrada", headerName: "M6 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m6PresDescC1",      headerName: "M6 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m6PresDescC2",      headerName: "M6 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m6NumeroEquipo",    headerName: "M6 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M7 =====
    { field: "m7TempEvapSalida",  headerName: "M7 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m7TempEvapEntrada", headerName: "M7 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m7PresDescC1",      headerName: "M7 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m7PresDescC2",      headerName: "M7 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m7NumeroEquipo",    headerName: "M7 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M8 =====
    { field: "m8TempEvapSalida",  headerName: "M8 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m8TempEvapEntrada", headerName: "M8 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m8PresDescC1",      headerName: "M8 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m8PresDescC2",      headerName: "M8 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m8NumeroEquipo",    headerName: "M8 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M9 =====
    { field: "m9TempEvapSalida",  headerName: "M9 Temp. Evap Salida",  minWidth: 200, flex: 1 },
    { field: "m9TempEvapEntrada", headerName: "M9 Temp. Evap Entrada", minWidth: 200, flex: 1 },
    { field: "m9PresDescC1",      headerName: "M9 Pres. Desc C1",      minWidth: 170, flex: 1 },
    { field: "m9PresDescC2",      headerName: "M9 Pres. Desc C2",      minWidth: 170, flex: 1 },
    { field: "m9NumeroEquipo",    headerName: "M9 Número de Equipo",   minWidth: 180, flex: 1 },

    // ===== M10 =====
    { field: "m10TempEvapSalida",  headerName: "M10 Temp. Evap Salida",  minWidth: 210, flex: 1 },
    { field: "m10TempEvapEntrada", headerName: "M10 Temp. Evap Entrada", minWidth: 210, flex: 1 },
    { field: "m10PresDescC1",      headerName: "M10 Pres. Desc C1",      minWidth: 180, flex: 1 },
    { field: "m10PresDescC2",      headerName: "M10 Pres. Desc C2",      minWidth: 180, flex: 1 },
    { field: "m10NumeroEquipo",    headerName: "M10 Número de Equipo",   minWidth: 190, flex: 1 },
  ];

  const licuador1CompColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "presSuccion", headerName: "Pres. Succión", minWidth: 160, flex: 1 },
    { field: "presDescarga", headerName: "Pres. Descarga", minWidth: 160, flex: 1 },

    { field: "tempRefrEvap", headerName: "Temp. Refr Evap", minWidth: 180, flex: 1 },
    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },

    { field: "tempCondEntrada", headerName: "Temp. Cond Entrada", minWidth: 180, flex: 1 },
    { field: "tempCondSalida", headerName: "Temp. Cond Salida", minWidth: 180, flex: 1 },

    { field: "tempDescarga", headerName: "Temp. Descarga", minWidth: 180, flex: 1 },
  ];

  const optichillerCT6Columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "presSuccionComp1", headerName: "Pres. Succión C1", minWidth: 180, flex: 1 },
    { field: "presSuccionComp2", headerName: "Pres. Succión C2", minWidth: 180, flex: 1 },
    { field: "presionDescargaComp1", headerName: "Pres. Descarga C1", minWidth: 180, flex: 1 },
    { field: "presionDescargaComp2", headerName: "Pres. Descarga C2", minWidth: 180, flex: 1 },

    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },
    { field: "tempTorreEntrada", headerName: "Temp. Torre Entrada", minWidth: 200, flex: 1 },
    { field: "tempTorreSalida", headerName: "Temp. Torre Salida", minWidth: 200, flex: 1 },

    { field: "tempDescargaComp1", headerName: "Temp. Descarga C1", minWidth: 200, flex: 1 },
    { field: "tempDescargaComp2", headerName: "Temp. Descarga C2", minWidth: 200, flex: 1 },
  ];

  const optichiller1CompColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "presionSuccionComp1", headerName: "Presión Succión Comp. 1", minWidth: 210, flex: 1 },
    { field: "presionDescargaComp1", headerName: "Presión Descarga Comp. 1", minWidth: 220, flex: 1 },

    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },

    { field: "tempTorreEntrada", headerName: "Temp. Torre Entrada", minWidth: 200, flex: 1 },
    { field: "tempTorreSalida", headerName: "Temp. Torre Salida", minWidth: 200, flex: 1 },

    { field: "tempDescargaComp1", headerName: "Temp. Descarga Compresor 1", minWidth: 240, flex: 1 },
  ];

  const optichiller1CompCT6Columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "presSuccionComp1", headerName: "Presion Succion Comp 1", minWidth: 210, flex: 1 },
    { field: "presDescargaComp1", headerName: "Presion Descarga Comp 1", minWidth: 220, flex: 1 },

    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },

    { field: "tempTorreEntrada", headerName: "Temp. Torre Entrada", minWidth: 200, flex: 1 },
    { field: "tempTorreSalida", headerName: "Temp. Torre Salida", minWidth: 200, flex: 1 },

    { field: "tempDescargaComp1", headerName: "Temp. Descarga Compresor 1", minWidth: 240, flex: 1 },
  ];

  const victex1CompColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
    { field: "tempProcesoSalida",  headerName: "Temp. Proceso Salida",  minWidth: 200, flex: 1 },
    { field: "tempDescarga",       headerName: "Temp. Descarga",       minWidth: 180, flex: 1 },
    { field: "tempAmbiente",       headerName: "Temp. Ambiente",       minWidth: 180, flex: 1 },

    { field: "presionSuccion",     headerName: "Presión Succión",      minWidth: 180, flex: 1 },
    { field: "presionDescarga",    headerName: "Presión Descarga",     minWidth: 180, flex: 1 },
  ];

  const fscV31CompColumns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
    { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

    { field: "tempEvapSalida",           headerName: "Temp. Evaporador Salida",      minWidth: 210, flex: 1 },
    { field: "tempEvapEntrada",          headerName: "Temp. Evaporador Entrada",     minWidth: 210, flex: 1 },
    { field: "presionSuccionComp1",      headerName: "Presión Succión Comp 1",       minWidth: 210, flex: 1 },
    { field: "presionDescargaComp1",     headerName: "Presión Descarga Comp 1",      minWidth: 220, flex: 1 },
    { field: "sobrecalentamientoComp1",  headerName: "Sobrecalentamiento Comp 1",    minWidth: 230, flex: 1 },
    { field: "tempSuccionComp1",         headerName: "Temp. Succión Comp 1",         minWidth: 200, flex: 1 },
  ];

  const fsc1CompColumns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

  { field: "tempEvapSalida",    headerName: "Temp. Evaporador Salida", minWidth: 210, flex: 1 },
  { field: "tempDescarga",      headerName: "Temp. Descarga",          minWidth: 180, flex: 1 },
  { field: "presionSuccion",    headerName: "Presión Succión",         minWidth: 180, flex: 1 },
  { field: "presionDescarga",   headerName: "Presión Descarga",        minWidth: 180, flex: 1 },
  { field: "sobrecalentamiento",headerName: "Sobrecalentamiento",      minWidth: 200, flex: 1 },
  { field: "tempSuccion",       headerName: "Temp. Succión",           minWidth: 180, flex: 1 },
];

const fscV21CompColumns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },

  { field: "tempEvapSalida",     headerName: "Temp. Evaporador Salida", minWidth: 210, flex: 1 },
  { field: "tempDescarga",       headerName: "Temp. Descarga",          minWidth: 180, flex: 1 },
  { field: "presionSuccion",     headerName: "Presión Succión",         minWidth: 180, flex: 1 },
  { field: "presionDescarga",    headerName: "Presión Descarga",        minWidth: 180, flex: 1 },
  { field: "sobrecalentamiento", headerName: "Sobrecalentamiento",      minWidth: 200, flex: 1 },
  { field: "tempSuccion",        headerName: "Temp. Succión",           minWidth: 180, flex: 1 },
];

export {
  optichiller2CompColumns,
  centrifugaColumns,
  cotherm2CompColumns,
  cotherm4CompColumns,
  cotherm4Comp2CCColumns,
  ezChiller2CompCT6Columns,
  fscColumns,
  fsc1CompColumns,
  fscUnicoColumns,
  fscV21CompColumns,
  fscV3Columns,
  fscV31CompColumns,
  licuador1CompColumns,
  optichillerCT6Columns,
  optichiller1CompColumns,
  optichiller1CompCT6Columns,
  victex1CompColumns,
};

